module.exports = {
  MAX_VALUE: 250000
};
